import type { UnknownAction } from 'redux'

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const isUnknownAction = (value: unknown): value is UnknownAction =>
  isRecord(value) && typeof value.type === 'string'

export const hasStringProperty = <Key extends string>(
  action: Record<string, unknown>,
  key: Key,
): action is Record<string, unknown> & Record<Key, string> =>
  typeof action[key] === 'string'

export const hasOptionalStringProperty = <Key extends string>(
  action: Record<string, unknown>,
  key: Key,
): action is Record<string, unknown> & Record<Key, string | undefined> =>
  typeof action[key] === 'string' || typeof action[key] === 'undefined'

export const getProperty = (value: unknown, key: string): unknown =>
  isRecord(value) ? value[key] : undefined
